import { render, staticRenderFns } from "./EmailDocumentList.vue?vue&type=template&id=1379cee6&scoped=true&"
import script from "./EmailDocumentList.vue?vue&type=script&lang=js&"
export * from "./EmailDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./EmailDocumentList.vue?vue&type=style&index=0&id=1379cee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1379cee6",
  null
  
)

export default component.exports